const ADMINISTRADOR = "admin";
const VENDEDOR = "vendedor";
const MODERADOR = "moderador";

export default {
  data() {
    return {
      locacaoCargos: {
        ADMINISTRADOR,
        VENDEDOR,
        MODERADOR
      }
    };
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    },

    locacaoCargoSlug() {
      if (!this.user) {
        return null;
      }

      return this.user.permissao_locacao_role;
    }
  },

  methods: {
    usuarioTemCargoDeLocacao(cargo) {
      if (this.user && this.user.admin) {
        return true;
      }

      const pesoUsuario = this.pesoCargo(this.locacaoCargoSlug);
      const pesoRequerido = this.pesoCargo(cargo);

      return pesoUsuario >= pesoRequerido;
    },

    pesoCargo(cargo) {
      if (!cargo) {
        return 0;
      }

      switch (cargo) {
        case VENDEDOR:
          return 1;
        case MODERADOR:
          return 2;
        case ADMINISTRADOR:
          return 3;
        default:
          return 0;
      }
    }
  }
};
